export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_03.0ed7d2a9.jpg";